import { FC, useEffect, useRef } from "react";
import { useParams } from "react-router-dom";
import useI18n from "../../../../../hooks/useTranslations";
import { useUprightTypesApi } from "../../../../../http/border/useUprightTypes";
import FlexContent from "../../../../ui/FlexContent";
import Header from "../../../../ui/Header";
import { BORDER } from "../../AdminSystemSettings";
import UprightTypeDetails from "./UprightTypeDetails";

const UprightType: FC = () => {
  const i18n = useI18n();
  const { systemId } = useParams<{ systemId: string }>();
  const { uprightTypeId } = useParams<{ uprightTypeId: string }>();
  const uprightTypesApi = useUprightTypesApi();

  const aborter = useRef(new AbortController());
  const { error, data, isMutating, trigger } = uprightTypesApi.getAdminUprightType(
    uprightTypeId!,
    aborter.current.signal,
  );

  const path = [
    { url: `/admin/systems`, display: i18n.translation.systems.all },
    { url: `/admin/systems/${systemId}`, display: BORDER },
    {
      url: `/admin/systems/${systemId}/settings?tab=5&u_t=2`,
      display: `${i18n.translation.common.settings}: ${i18n.translation.uprightTypes.plural}`,
    },
    { display: data?.name ?? "" },
  ];

  useEffect(() => {
    uprightTypeId && trigger();
  }, [uprightTypeId]);

  return (
    <>
      <Header title={`${i18n.translation.uprightTypes.singular}: ${data?.name ?? ""}`} error={error} path={path} />
      <FlexContent padding direction="row">
        <UprightTypeDetails uprightType={!error ? data : undefined} disabled={isMutating || !!error} />
      </FlexContent>
    </>
  );
};

export default UprightType;
